import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";

export default function CtaBand({ eyebrow = "Start Planning", heading, lead, cta, to = "/contact/" }) {
  return (
    <section className="relative overflow-hidden bg-navy py-20 md:py-24">
      <div className="mx-auto max-w-3xl px-5 text-center md:px-10">
        <Reveal>
          <div className="flex justify-center">
            <Eyebrow light>{eyebrow}</Eyebrow>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display text-4xl font-medium leading-tight text-ivory md:text-5xl">{heading}</h2>
        </Reveal>
        {lead && (
          <Reveal delay={0.18}>
            <p className="mx-auto mt-5 max-w-xl text-sm font-light leading-relaxed text-ivory/75 md:text-base">{lead}</p>
          </Reveal>
        )}
        <Reveal delay={0.26}>
          <Link
            to={to}
            data-testid={`cta-band-${cta.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}
            className="group mt-9 inline-flex items-center gap-3 bg-gold px-10 py-4 text-xs font-semibold uppercase tracking-[0.22em] text-navy transition-colors duration-500 hover:bg-gold-2"
          >
            {cta}
            <ArrowRight className="h-4 w-4 transition-transform duration-500 group-hover:translate-x-1.5" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
